import { render, staticRenderFns } from "./dankejindu.vue?vue&type=template&id=356dfac2&scoped=true&"
import script from "./dankejindu.vue?vue&type=script&lang=js&"
export * from "./dankejindu.vue?vue&type=script&lang=js&"
import style0 from "./dankejindu.vue?vue&type=style&index=0&id=356dfac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356dfac2",
  null
  
)

export default component.exports